module.exports = __webpack_public_path__ + "img/szegyenlos_lanyok_2.63e2d203.jpg";